module.exports = __webpack_public_path__ + "assets/img/placeholder.90d523dd.png";